import React from "react";
import {
  Clock,
  Zap,
  Users,
  AlertTriangle,
  DollarSign,
  ShieldCheck,
  MessageCircle,
  MapPin,
} from "lucide-react";

const features = [
  { icon: Clock, title: "Atendimento 24 horas", desc: "Disponíveis dia, noite e finais de semana." },
  { icon: Zap, title: "Chegada rápida", desc: "Equipes em pontos estratégicos da região." },
  { icon: Users, title: "Equipe especializada", desc: "Profissionais experientes e treinados." },
  { icon: AlertTriangle, title: "Atendimento emergencial", desc: "Pronto para situações urgentes." },
  { icon: DollarSign, title: "Preço justo", desc: "Orçamento honesto antes de cada serviço." },
  { icon: ShieldCheck, title: "Segurança e confiança", desc: "Trabalho cuidadoso, sem riscos." },
  { icon: MessageCircle, title: "Suporte pelo WhatsApp", desc: "Resposta imediata, sem espera." },
  { icon: MapPin, title: "Cobertura regional", desc: "Morumbi, Campo Limpo, Vila Andrade e Taboão." },
];

export default function WhyChoose() {
  return (
    <section
      id="diferenciais"
      data-testid="why-choose-section"
      className="relative py-24 lg:py-32 bg-[#050505] noise-overlay"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#f3bd0e]/40 rounded-sm mb-5">
              <span className="w-1.5 h-1.5 bg-[#f3bd0e]"></span>
              <span className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#f3bd0e]">
                Por que escolher
              </span>
            </div>
            <h2
              className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight text-white"
              data-testid="why-title"
            >
              Profissionalismo
              <br />
              <span className="text-[#f3bd0e]">na hora certa.</span>
            </h2>
            <p className="mt-5 text-white/70 leading-relaxed">
              Cada minuto importa quando você está parado na rua. Por isso a
              JR foi construída sobre três pilares:{" "}
              <span className="text-white font-semibold">Rapidez</span>,{" "}
              <span className="text-white font-semibold">Segurança</span> e{" "}
              <span className="text-white font-semibold">Confiança</span>.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((f, idx) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.title}
                  data-testid={`feature-${idx}`}
                  className="group flex items-start gap-4 p-5 bg-black/60 border border-white/10 rounded-md hover:border-[#f3bd0e]/60 hover:bg-black transition"
                >
                  <div className="shrink-0 w-11 h-11 rounded-md bg-[#f3bd0e]/10 border border-[#f3bd0e]/30 flex items-center justify-center group-hover:bg-[#f3bd0e] transition">
                    <Icon className="w-5 h-5 text-[#f3bd0e] group-hover:text-black transition" strokeWidth={2.4} />
                  </div>
                  <div>
                    <h3 className="font-display text-base uppercase tracking-tight text-white">
                      {f.title}
                    </h3>
                    <p className="text-sm text-white/60 mt-1.5 leading-relaxed">
                      {f.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
